import {
  Box,
  IconButton,
  Button,
  Typography,
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Radio,
  Input,
  RadioGroup,
  FormControl,
  FormLabel
} from "@mui/material";

import { useEffect, useState } from "react";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { useAuth } from "../../../AuthContext";
import { tokens } from "../../../theme";
import { ToastContainer, toast } from "react-toastify";
import { Form } from "react-bootstrap";

import TextField from "@mui/material/TextField";
import Divider from "@mui/material/Divider";

import DeleteIcon from "@mui/icons-material/Delete";
import SendIcon from "@mui/icons-material/Send";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import AddIcon from "@mui/icons-material/Add";

import "react-toastify/dist/ReactToastify.css";

import Nodata from "../../../assets/errors/nodata.png";

const Announcements = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);

  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);

  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openAddDialog, setOpenAddDialog] = useState(false);

  const [announcementToDelete, setAnnouncementToDelete] = useState(null);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const { getData, addData, updateData, deleteData } = useAuth();

  const [formData, setFormData] = useState({
    content: "",
    link_one_lable: "",
    link_one: "",
    link_two_lable: "",
    link_two: "",
    image: '',
    is_active: "0"
  });

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await getData(
          "proccess.php",
          "Annousement_V2"
        );

        if (response.success) {
          setAnnouncements(response.data);
        } else {
          toast.error(response.message || "Failed to load announcements");
        }
      } catch (err) {
        toast.error("Network error: Failed to fetch announcements");
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [getData]);

  const handleAddClick = () => {
    setFormData({
      content: "",
      link_one_lable: "",
      link_one: "",
      link_two_lable: "",
      link_two: "",
      image: "",
      is_active: "0"
    });

    setOpenAddDialog(true);
  };

  const handleEditClick = (item) => {
    setSelectedAnnouncement(item);

    setFormData({
      content: item.content || "",
      link_one_lable: item.link_one_lable || "",
      link_one: item.link_one || "",
      link_two_lable: item.link_two_lable || "",
      link_two: item.link_two || "",
      image: item.image || "",
      is_active: item.is_active ? "1" : "0"
    });

    setOpenEditDialog(true);
  };

  const handleDeleteClick = (item) => {
    setAnnouncementToDelete(item);
    setOpenDeleteDialog(true);
  };

  const handleDeleteConfirm = async () => {
    setLoading(true);
    try {
      const response = await deleteData(
        "proccess.php",
        "Annousement_V2",
        announcementToDelete.id
      );

      if (response.success) {
        toast.success("Announcement deleted");

        setAnnouncements(
          announcements.filter(
            (item) => item.id !== announcementToDelete.id
          )
        );
      } else {
        toast.error(response.message || "Delete failed");
      }
    } catch (err) {
      toast.error("Network error");
    } finally {
      setLoading(false);
    }

    setOpenDeleteDialog(false);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    setFormData(prev => ({
      ...prev,
      image: e.target.files[0]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let response;
    setLoading(true);

    try {
      if (selectedAnnouncement) {
        response = await updateData(
          "proccess.php",
          "Annousement_V2",
          formData,
          selectedAnnouncement.id
        );
      } else {
        response = await addData(
          "proccess.php",
          "Annousement_V2",
          formData
        );
      }

      if (response.success) {
        toast.success("Saved successfully");
        setAnnouncements(response.data);
      } else {
        toast.error(response.message || "Operation failed");
      }
    } catch (err) {
      toast.error("Network error");
    } finally {
      setLoading(false);
    }

    setOpenEditDialog(false);
    setOpenAddDialog(false);
    setSelectedAnnouncement(null);
  };

  const columns = [
    { field: "id", headerName: "ID", width: 70 },

    {
      field: "content",
      headerName: "Content",
      flex: 1,
      minWidth: 120
    },

    {
      field: "link_one_lable",
      headerName: "Link One Label",
      flex: 1,
      minWidth: 120
    },

    {
      field: "link_one",
      headerName: "Link One",
      flex: 1,
      minWidth: 120
    },

    {
      field: "link_two_lable",
      headerName: "Link Two Label",
      flex: 1,
      minWidth: 120
    },

    {
      field: "link_two",
      headerName: "Link Two",
      flex: 1,
      minWidth: 120
    },

    {
      field: "is_active",
      headerName: "Status",
      width: 120,
      renderCell: (params) => (
        <Typography
          sx={{
            fontWeight: "bold",
            color: params.value
              ? colors.green[400]
              : colors.red[400]
          }}
        >
          {params.value ? "Active" : "Inactive"}
        </Typography>
      )
    },

    { 
          field: "image", 
          headerName: "Image / Logo", 
          flex: 1,
          minWidth: 120,
          renderCell: (params) => (
            <Box width={50} height={50}>
              {params.value ? (
                <img
                  src={`https://mindsinaction.com.na/assets/media/pictures/${params.value}`}
                  alt={params.value || "Module"}
                  style={{ width: 50, height: 50, objectFit: "cover" }}
                  onClick={() => window.open(`https://mindsinaction.com.na/assets/media/pictures/${params.value}`, "_blank")}
                />
              ) : (
                "No image"
              )}
            </Box>
          )
        },

    {
      field: "actions",
      headerName: "Actions",
      width: 120,
      sortable: false,
      renderCell: (params) => (
        <Box display="flex" gap="8px">
          <IconButton
            onClick={() => handleEditClick(params.row)}
            sx={{ color: colors.blue[400] }}
          >
            <EditNoteOutlinedIcon />
          </IconButton>

          <IconButton
            onClick={() => handleDeleteClick(params.row)}
            sx={{ color: colors.orange[400] }}
          >
            <DeleteForeverOutlinedIcon />
          </IconButton>
        </Box>
      )
    }
  ];

  const NoDataOverlay = () => (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100%"
    >
      <img
        src={Nodata}
        alt="No data"
        style={{ width: 150, marginBottom: 16 }}
      />
      <Typography>No special announcements available</Typography>
    </Box>
  );

  return (
    <Box m="10px">
      <ToastContainer />

      <Dialog
        open={openEditDialog || openAddDialog}
        onClose={() => {
          setOpenEditDialog(false);
          setOpenAddDialog(false);
          setSelectedAnnouncement(null);
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {selectedAnnouncement
            ? "Edit Announcement"
            : "Add Announcement"}
        </DialogTitle>

        <DialogContent>
          <Form
            onSubmit={handleSubmit}
            style={{ padding: "1rem" }}
          >
            <TextField
              fullWidth
              label="Announcement"
              name="content"
              multiline
              minRows={3}
              sx={{marginBottom: '1rem'}}
              value={formData.content}
              onChange={handleFormChange}
              required
            />

            <TextField
              fullWidth
              id="link_one_lable"
              label="Link One Lable"
              name="link_one_lable"
              sx={{marginBottom: '1rem'}}
              value={formData.link_one_lable}
              onChange={handleFormChange}
            />

            <TextField
              fullWidth
              id="link_one"
              label="Link One"
              name="link_one"
              sx={{marginBottom: '1rem'}}
              value={formData.link_one}
              onChange={handleFormChange}
            />

            <TextField
              fullWidth
              id="link_two_lable"
              label="Link Two Lable"
              name="link_two_lable"
              sx={{marginBottom: '1rem'}}
              value={formData.link_two_lable}
              onChange={handleFormChange}
            />

            <TextField
              fullWidth
              id="link_two"
              label="Link Two"
              name="link_two"
              sx={{marginBottom: '1rem'}}
              value={formData.link_two}
              onChange={handleFormChange}
            />

            <Box width={"100%"} sx={{marginBottom: '1rem'}}>
                <label>Image/Logo</label>
                <Input 
                  type="file" 
                  style={{width: "100%"}} 
                  id="image" 
                  name="image"
                  onChange={handleFileChange}
                  required={!selectedAnnouncement}
                />
            </Box>

            <FormControl sx={{ mt: 2 }}>
              <FormLabel>Status</FormLabel>

              <RadioGroup
                row
                name="is_active"
                value={formData.is_active}
                onChange={handleFormChange}
              >
                <FormControlLabel
                  value="1"
                  control={<Radio />}
                  label="Active"
                />
                <FormControlLabel
                  value="0"
                  control={<Radio />}
                  label="Inactive"
                />
              </RadioGroup>
            </FormControl>
          </Form>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setOpenEditDialog(false);
              setOpenAddDialog(false);
            }}
          >
            Cancel
          </Button>

          <Button
            onClick={handleSubmit}
            variant="contained"
            endIcon={<SendIcon />}
            sx={{ backgroundColor: colors.blue[400] }}
            disabled={loading}
          >
            {selectedAnnouncement ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
      >
        <DialogTitle>Confirm Delete</DialogTitle>

        <DialogContent>
          <Typography>
            Are you sure you want to delete this
            announcement?
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setOpenDeleteDialog(false)}
          >
            Cancel
          </Button>

          <Button
            onClick={handleDeleteConfirm}
            variant="contained"
            startIcon={<DeleteIcon />}
            sx={{ backgroundColor: colors.red[400] }}
            disabled={loading}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Box
        mb="30px"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box>
          <Typography
            variant="h4"
            fontWeight="bold"
          >
            Special Announcements
          </Typography>

          <Typography
            variant="h6"
            color={colors.blue[400]}
          >
            Manage public announcements
          </Typography>
        </Box>

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleAddClick}
          sx={{
            backgroundColor: colors.blue[400]
          }}
        >
          Add Announcement
        </Button>
      </Box>

      <Divider />

      <Box
        sx={{ height: "calc(100vh - 250px)", width: "100%" }}
        mt="1rem"
      >
        <DataGrid
          rows={announcements}
          columns={columns}
          getRowId={(row) => row.id}
          loading={loading}
          slots={{
            toolbar: () => (
              <GridToolbarQuickFilter />
            ),
            noRowsOverlay: NoDataOverlay
          }}
        />
      </Box>
    </Box>
  );
};

export default Announcements;